import { createContext, useContext } from "react";
import { useUserLocationState } from "../hooks/useUserLocationState";

const LocationContext = createContext(null);

export function LocationProvider({ children }) {
  const value = useUserLocationState();

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
}

function useUserLocation() {
  const context = useContext(LocationContext);

  if (!context) {
    throw new Error("useUserLocation must be used within LocationProvider");
  }

  return context;
}

export default useUserLocation;
